import { labelledParticipant } from "components/Meetings/components/models";
import { Store } from "./rootReducer";

export type Nullable<T> = T | null;

//Types
export enum RightPanelActionType {
  MEETING_DETAILS = "MEETING_DETAILS",
  OPEN_RIGHT_PANEL = "OPEN_RIGHT_PANEL",
  CLOSE_RIGHT_PANEL = "CLOSE_RIGHT_PANEL",
}

// State
export type PanelState =
  | {
      panelType: null;
      data: null;
    }
  | {
      panelType: RightPanelActionType.MEETING_DETAILS;
      data: {
        title: string;
        eventsId: number;
        assessmentType: string;
        startDate: Date;
        participants: labelledParticipant[];
        assessmentProngIdList: string[];
        assessmentName: string;
        hasBookedCandidates: boolean;
      };
    };

export const initialState: PanelState = {
  panelType: null,
  data: null,
};

// Actions
export type Action =
  | {
      type: RightPanelActionType.OPEN_RIGHT_PANEL;
      payload: OpenRightPanel;
    }
  | {
      type: RightPanelActionType.CLOSE_RIGHT_PANEL;
      payload: null;
    };

// Reducer
export default function modalReducer(
  state = initialState,
  action: Action
): PanelState {
  switch (action.type) {
    case RightPanelActionType.OPEN_RIGHT_PANEL:
      return {
        ...state,
        panelType: action.payload.panelType,
        data: action.payload.data,
      };
    case RightPanelActionType.CLOSE_RIGHT_PANEL:
      return {
        ...state,
        panelType: null,
        data: null,
      };
    default:
      return state;
  }
}

export type OpenRightPanel = {
  panelType: any | null;
  data: any | null;
};

// Action creators
export const openRightPanel = (payload: OpenRightPanel) => ({
  type: RightPanelActionType.OPEN_RIGHT_PANEL,
  payload,
});

export const closeRightPanel = () => ({
  type: RightPanelActionType.CLOSE_RIGHT_PANEL,
});

// Selectors
export const selectRightPanelState = (state: Store) => state.rightPanel;
export const selectRightPanelType = (state: Store) =>
  state.rightPanel.panelType;
